export type AnonymisationType = 'full_name' | 'first_initial' | 'initials_only';

/**
 * Returns a pupil's display name according to their anonymisation setting.
 *
 * full_name:     "Emma Johnson"
 * first_initial: "E. Johnson"   (first initial uppercased; last name as entered)
 * initials_only: "EJ"           (both initials uppercased)
 */
export function formatDisplayName(
  firstName: string,
  lastName: string,
  anonymisation: AnonymisationType,
): string {
  switch (anonymisation) {
    case 'full_name':
      return `${firstName} ${lastName}`;
    case 'first_initial':
      return `${firstName.charAt(0).toUpperCase()}. ${lastName}`;
    case 'initials_only':
      return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
  }
}
